// External Dependencies
import Marionette from 'backbone.marionette';
import Backbone from 'backbone';

// Internal Dependencies - screens/views/templates
import ecqmContainerView  from '../../../../templates/CPC/Ecqm/ecqmContainerView';

// Internal Dependencies - models/collections

export default Marionette.LayoutView.extend({

	className: 'ecqm-container-view',

	getTemplate: function() {
		return ecqmContainerView( );
	},

});
